
window.addEventListener("load", (() => { // fired when content is loaded not just the DOM
	// Dispatch window resize event to re-align carousel elements after content is loaded
	const resetImages = () => {
		let images = document.querySelectorAll(".woocommerce-product-gallery__image");
		if (images.length > 1) {
			for (const image of images) {
				console.log("set image unset");
				image.style.removeProperty('width');
			}
		}
		window.dispatchEvent(new Event('resize'));
	}

	resetImages();
	
	//"flexslider"
	setTimeout(() => {
		console.log("Delayed carousel fix again.");
		resetImages();
	}, 1000);
}));